const isDevelopment = process.env.NODE_ENV === 'development'
const isProduction = process.env.NODE_ENV === 'production'
const isLocalhost = window.location.host.indexOf('localhost') > -1

export const ENV = {
  isDevelopment,
  isProduction,
  isLocalhost,
} as const
